import theme from './theme.module.scss'

function extractTokens(type) {
  return Object.keys(theme)
    .filter(key => key.substr(0, type.length) === type)
    .reduce((all, key) => {
      let label = key.replace(type, '')
      label = label.charAt(0).toLowerCase() + label.slice(1)
      return { ...all, [label]: theme[key] }
    }, {})
}

const colors = extractTokens('colors')

export default { colors }
